module.exports = __webpack_public_path__ + "img/avatar-s-5.cb5f635c.jpg";